/*
 * Sanftes Nachrendern.
 *
 * Der Warenkorb holt sich nach jeder Aenderung die Section frisch vom Server
 * und hat sie bisher per `innerHTML` komplett ersetzt. Fuer eine geaenderte
 * Zahl wurde damit der halbe Drawer neu gebaut, mit allem was daran haengt:
 *
 * - Jedes <img is="lazy-image"> war ein neues Element. Im Konstruktor ist
 *   `complete` noch false, also legte es den grauen Ladebalken ueber sein
 *   Medium und nahm ihn erst nach dem load-Event wieder weg — bis zu 150 ms
 *   graue Platzhalter bei jedem Tap auf +/-, obwohl das Bild im Cache lag.
 * - Die Einblend-Animationen (data-animate) liefen jedes Mal von vorne.
 * - Scrollposition im Drawer und im Empfehlungs-Karussell sprang zurueck.
 * - Der Fokus im Mengenfeld ging verloren.
 * - Eingebundene Fremdskripte (PayPal-Messaging) wurden neu aufgebaut.
 *
 * morph() gleicht stattdessen den vorhandenen Baum an den neuen an: gleiche
 * Knoten bleiben stehen, nur was sich wirklich unterscheidet wird angefasst.
 *
 * Nicht angeglichen, sondern ganz getauscht werden Elemente, die ihr eigenes
 * Markup umbauen oder beim Einsetzen etwas ausloesen — fuer die waere ein
 * Angleichen falsch, siehe MORPH_REPLACE.
 */
(function () {
  window.theme = window.theme || {};

  /*
   * Diese Elemente werden ersetzt statt angeglichen:
   *
   * - price-money schreibt im Konstruktor sein eigenes <bdi> um (Zahl, Nachkomma
   *   hochgestellt, Symbol). Der Server liefert den rohen Preis. Wuerde man das
   *   angleichen, stuende danach der unformatierte Text da, weil der
   *   Konstruktor kein zweites Mal laeuft.
   * - cart-milestone-picker verlaesst sich darauf, bei jedem Rendern neu
   *   gebaut zu werden: das automatische Einloesen eines Geschenks und das
   *   Entfernen abgelaufener Zeilen haengen an connectedCallback und an
   *   Attributen, die Liquid frisch mitgibt (siehe assets/cart-milestone-picker.js).
   * - cart-recommendations holt seinen Inhalt in connectedCallback selbst nach.
   *   Bliebe das alte Element stehen, haetten wir die leere Huelle stehen.
   * - gift-wrapping und gift-quantity lesen Anzahlen (Artikel, Verpackungen)
   *   einmal im Konstruktor und gleichen die Verpackungsmenge daran an. Stehen
   *   gelassen rechneten sie mit dem Warenkorb von vorhin (assets/gift-wrapping.js).
   *
   * data-morph="replace" laesst sich im Markup fuer dieselbe Behandlung setzen.
   */
  const MORPH_REPLACE =
    'price-money, cart-milestone-picker, cart-recommendations, gift-wrapping, gift-quantity, [data-morph="replace"]';

  /*
   * Felder mit einer Eingabe, die noch nicht beim Server ist. Der Mengen-Stepper
   * wartet 300 ms, bevor er schickt (assets/cart.js). Kam in der Zeit die
   * Antwort auf die vorige Aenderung zurueck, setzte das Nachrendern das Feld
   * auf deren Stand zurueck, und der neue Tap ging verloren. assets/cart.js
   * traegt ein Feld beim Tippen hier ein und beim Abschicken wieder aus.
   */
  const keepValue = new WeakSet();

  /*
   * Bleibt unangetastet, egal was der Server schickt — und wird auch nicht
   * entfernt, wenn es im neuen Markup gar nicht vorkommt.
   *
   * Der PayPal-Block im Drawer-Footer wird von der App per Skript eingesetzt,
   * im Section-Markup vom Server steht er nicht. Ohne diese Ausnahme wuerde er
   * bei jeder Mengenaenderung weggeraeumt und von der App neu aufgebaut, also
   * genau das Flackern, das wir hier loswerden wollen.
   */
  /*
   * Geschlossene Einheiten: entweder identisch oder komplett getauscht.
   *
   * Ein Icon ist eine Zeichnung, keine Struktur. Den LKW Pfad fuer Pfad in ein
   * Geschenk umzubauen kostet nur Arbeit und geht daneben, sobald die beiden
   * unterschiedlich viele Pfade haben. Icons tragen ausserdem keinen Zustand,
   * den man erhalten muesste.
   */
  const MORPH_ATOMIC = 'svg';

  const MORPH_KEEP = '[data-morph="keep"], .paypal-button-block';

  /*
   * Warenkorb-Zeilen bekommen in sections/mini-cart.liquid einen data-line-key
   * (Shopifys line item key). Damit wandert beim Entfernen oder Einfuegen einer
   * Zeile wirklich nur diese eine Zeile, statt dass alle folgenden Zeilen den
   * Inhalt ihres Nachbarn uebernehmen — was genau die Bild-Platzhalter
   * zurueckbringen wuerde, die wir hier loswerden wollen.
   */
  function nodeKey(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return null;
    /*
     * Bewusst nur data-line-key und nicht zusaetzlich die id: die ids im
     * Warenkorb sind durchnummeriert (Quantity-1, Remove-2, ...) und wandern
     * mit, sobald eine Zeile wegfaellt. Als Schluessel gelesen wuerden sie
     * genau die Knoten neu bauen, die wir stehen lassen wollen.
     */
    return node.getAttribute('data-line-key');
  }

  /* Sucht ab `from` nach einem Geschwisterknoten mit diesem Schluessel. */
  function findKeyed(from, key) {
    let node = from;
    while (node) {
      if (nodeKey(node) === key) return node;
      node = node.nextSibling;
    }
    return null;
  }

  function morphAttributes(target, source) {
    const sourceAttributes = source.attributes;
    for (let i = sourceAttributes.length - 1; i >= 0; i--) {
      const { name, value } = sourceAttributes[i];
      if (target.getAttribute(name) !== value) target.setAttribute(name, value);
    }

    const targetAttributes = target.attributes;
    for (let i = targetAttributes.length - 1; i >= 0; i--) {
      const { name } = targetAttributes[i];
      if (!source.hasAttribute(name)) target.removeAttribute(name);
    }
  }

  /*
   * Formularfelder tragen ihren Stand im Property, nicht im Attribut. Ohne das
   * hier wuerde ein Mengenfeld, in dem gerade jemand tippt, zwar das richtige
   * value-Attribut bekommen, aber die angezeigte Zahl bliebe die alte.
   */
  function morphFormState(target, source) {
    if (target instanceof HTMLInputElement) {
      if (target.type === 'checkbox' || target.type === 'radio') {
        target.checked = source.hasAttribute('checked');
      } else if (
        target !== document.activeElement &&
        !keepValue.has(target) &&
        target.value !== source.getAttribute('value')
      ) {
        target.value = source.getAttribute('value') || '';
      }
      target.disabled = source.hasAttribute('disabled');
      return;
    }

    if (target instanceof HTMLTextAreaElement) {
      if (target !== document.activeElement) target.value = source.textContent;
      return;
    }

    if (target instanceof HTMLSelectElement || target instanceof HTMLButtonElement) {
      target.disabled = source.hasAttribute('disabled');
    }
  }

  function replaceNode(target, source) {
    const fresh = document.importNode(source, true);
    target.replaceWith(fresh);
    return fresh;
  }

  function morphNode(target, source) {
    if (target.nodeType !== source.nodeType || target.nodeName !== source.nodeName) {
      return replaceNode(target, source);
    }

    if (target.nodeType === Node.TEXT_NODE || target.nodeType === Node.COMMENT_NODE) {
      if (target.nodeValue !== source.nodeValue) target.nodeValue = source.nodeValue;
      return target;
    }

    if (target.nodeType !== Node.ELEMENT_NODE) return target;

    if (target.matches(MORPH_KEEP)) return target;
    if (target.matches(MORPH_REPLACE)) return replaceNode(target, source);

    if (target.matches(MORPH_ATOMIC)) {
      return target.outerHTML === source.outerHTML ? target : replaceNode(target, source);
    }

    morphAttributes(target, source);
    morphFormState(target, source);

    /* <textarea> traegt seinen Inhalt im value, Kinder waeren hier falsch. */
    if (!(target instanceof HTMLTextAreaElement)) {
      morphChildren(target, source);
    }

    return target;
  }

  /*
   * Liquid setzt zwischen die Elemente reichlich Zeilenumbrueche. Die duerfen
   * beim Abgleich nicht mitzaehlen: kommt eine Zeile dazu, bringt sie einen
   * Umbruch mit, und ab da laege jeder Knoten gegen den falschen Partner —
   * genau die Verschiebung, wegen der sonst alle Bilder neu gebaut wuerden.
   */
  function isFiller(node) {
    return node.nodeType === Node.TEXT_NODE && !/\S/.test(node.nodeValue);
  }

  function isKept(node) {
    return node.nodeType === Node.ELEMENT_NODE && node.matches(MORPH_KEEP);
  }

  function nextMeaningful(node) {
    while (node && isFiller(node)) node = node.nextSibling;
    return node;
  }

  /*
   * Einfuegen mitsamt dem Umbruch davor, falls es einen gab: in Fliesstext
   * haelt das Leerzeichen zwischen zwei Elementen die Woerter auseinander.
   */
  function insertFrom(target, source, before) {
    const filler = source.previousSibling;
    const previous = before ? before.previousSibling : target.lastChild;

    /* Nur wenn an der Stelle wirklich noch keiner steht — sonst sammeln sich
       ueber viele Durchlaeufe leere Textknoten an. */
    if (filler && isFiller(filler) && previous && !isFiller(previous)) {
      target.insertBefore(document.importNode(filler, false), before || null);
    }

    const inserted = document.importNode(source, true);
    target.insertBefore(inserted, before || null);
    return inserted;
  }

  /*
   * Grobe Wiedererkennung ohne Schluessel: gleicher Tag und gleiche Klassen.
   * Reicht, um zu unterscheiden, ob ein Knoten dazugekommen oder weggefallen
   * ist — Feinheiten klaert danach morphNode.
   */
  function isSimilar(a, b) {
    if (!a || !b || a.nodeType !== b.nodeType) return false;
    if (a.nodeType !== Node.ELEMENT_NODE) return true;
    return a.nodeName === b.nodeName && a.getAttribute('class') === b.getAttribute('class');
  }

  /*
   * Sucht ab `from` den naechsten aehnlichen Knoten. Mehrere Schritte weit,
   * weil auch mal mehrere Knoten auf einmal dazukommen — die Meilenstein-
   * Auswahl bringt zum Beispiel <link>, <style> und ihr eigenes Element mit.
   */
  const LOOKAHEAD = 10;

  function findSimilar(from, reference) {
    let node = nextMeaningful(from);
    for (let i = 0; node && i < LOOKAHEAD; i++) {
      if (isSimilar(node, reference)) return node;
      node = nextMeaningful(node.nextSibling);
    }
    return null;
  }

  /*
   * Gleicht den Umbruch zwischen zwei Knoten an. Ob dort einer steht, haengt
   * an Liquids Trim-Markierungen und kann sich zwischen zwei Zustaenden
   * unterscheiden — zwischen zwei Woertern im Fliesstext waere das ein
   * sichtbarer Unterschied.
   */
  function syncFiller(target, oldChild, newChild) {
    const wanted = newChild.previousSibling;
    const present = oldChild.previousSibling;
    const wants = wanted && isFiller(wanted);
    const has = present && isFiller(present);

    if (wants && !has) {
      target.insertBefore(document.importNode(wanted, false), oldChild);
    } else if (!wants && has) {
      present.remove();
    }
  }

  function morphChildren(target, source) {
    let oldChild = nextMeaningful(target.firstChild);
    let newChild = nextMeaningful(source.firstChild);

    while (newChild) {
      const nextNew = nextMeaningful(newChild.nextSibling);

      /*
       * Ein keep-Knoten, der auch im Server-Markup steht (Express-Checkout im
       * Drawer), ist schon da. Ohne diesen Abgleich kaeme er bei jedem
       * Durchlauf ein weiteres Mal dazu, weil der vorhandene unten nur
       * uebersprungen wird.
       */
      if (isKept(newChild)) {
        const existing = [...target.children].find((node) => isKept(node) && isSimilar(node, newChild));
        if (existing) {
          if (existing === oldChild) oldChild = nextMeaningful(oldChild.nextSibling);
          newChild = nextNew;
          continue;
        }
      }

      /* Fremd eingesetzte Knoten ueberspringen, nicht dagegen abgleichen. */
      while (oldChild && isKept(oldChild)) oldChild = nextMeaningful(oldChild.nextSibling);

      if (!oldChild) {
        insertFrom(target, newChild, null);
        newChild = nextNew;
        continue;
      }

      const key = nodeKey(newChild);
      if (key) {
        const match = findKeyed(oldChild, key);
        if (match) {
          /* Passende Zeile nach vorne holen, statt sie neu zu bauen. */
          if (match !== oldChild) {
            target.insertBefore(match, oldChild);
            oldChild = match;
          }
        } else {
          addedLines.push(insertFrom(target, newChild, oldChild));
          newChild = nextNew;
          continue;
        }
      }

      /*
       * Kein Schluessel und die beiden passen nicht zueinander? Dann ist
       * entweder etwas dazugekommen oder weggefallen. Ein Blick auf den
       * jeweils naechsten Knoten sagt, welches von beidem — ohne das wuerde
       * zum Beispiel der ganze Drawer-Footer neu gebaut, sobald die
       * Meilenstein-Auswahl davor auftaucht oder verschwindet.
       */
      if (!key && !isSimilar(oldChild, newChild)) {
        /* Taucht der aktuelle Zielknoten weiter hinten in der Quelle auf?
           Dann ist alles davor dazugekommen. */
        if (findSimilar(newChild.nextSibling, oldChild)) {
          insertFrom(target, newChild, oldChild);
          newChild = nextNew;
          continue;
        }

        /* Umgekehrt: steht der Quellknoten weiter hinten im Ziel? Dann ist
           alles davor weggefallen. */
        const survivor = findSimilar(oldChild.nextSibling, newChild);
        if (survivor) {
          let node = oldChild;
          while (node && node !== survivor) {
            const next = node.nextSibling;
            /* Den Umbruch direkt vor dem Ueberlebenden stehen lassen — in der
               Quelle steht er auch dort. */
            const isTrailingFiller = isFiller(node) && next === survivor;
            if (!isKept(node) && !isTrailingFiller) node.remove();
            node = next;
          }
          oldChild = survivor;
        }
      }

      syncFiller(target, oldChild, newChild);

      /* morphNode kann oldChild ersetzen, der Nachfolger muss vorher fest stehen. */
      const nextOld = nextMeaningful(oldChild.nextSibling);
      morphNode(oldChild, newChild);
      oldChild = nextOld;
      newChild = nextNew;
    }

    /* Was der Server nicht mehr schickt, faellt weg — samt der Umbrueche dazwischen. */
    while (oldChild) {
      const next = oldChild.nextSibling;
      if (!isKept(oldChild)) oldChild.remove();
      oldChild = next;
    }

    /* Abschliessender Umbruch wie in der Quelle: beim Entfernen der letzten
       Zeile faellt er oben mit weg, sonst driftet das Markup ueber viele
       Durchlaeufe vom frischen Render ab. */
    const sourceTail = source.lastChild;
    const targetTail = target.lastChild;
    if (sourceTail && isFiller(sourceTail) && !(targetTail && isFiller(targetTail))) {
      target.appendChild(document.importNode(sourceTail, false));
    } else if (targetTail && isFiller(targetTail) && !(sourceTail && isFiller(sourceTail))) {
      targetTail.remove();
    }
  }

  /*
   * Bringt den Inhalt von `target` auf den Stand von `html`.
   *
   * `html` ist der innere Markup-Text, so wie ihn die Section liefert. Geparst
   * wird ueber <template>, damit auch <link> und <script> dort stehen bleiben,
   * wo sie hingehoeren — der DOMParser wuerde sie in den <head> des
   * Hilfsdokuments schieben.
   */
  function morph(target, html) {
    if (!target) return;

    const template = document.createElement('template');
    template.innerHTML = html;
    addedLines = [];
    morphChildren(target, template.content);
    revealAddedLine();
  }

  /*
   * Neue Warenkorb-Zeilen, die beim letzten Angleichen dazugekommen sind.
   * Shopify setzt eine neue Zeile oben in die Liste — das Geschenk vom
   * Meilenstein landete damit oberhalb des sichtbaren Bereichs, wenn der
   * Kunde weiter unten auf + getippt hatte, und er bekam nicht mit, dass es
   * drin ist. Nur im Drawer; auf /cart wuerde das die ganze Seite schieben.
   */
  let addedLines = [];

  function revealAddedLine() {
    const line = addedLines.find((node) => node.closest && node.closest('.mini-cart__main'));
    addedLines = [];
    if (!line) return;

    const scroller = line.closest('.mini-cart__main');
    const lineTop = line.getBoundingClientRect().top - scroller.getBoundingClientRect().top;
    const lineBottom = lineTop + line.offsetHeight;

    if (lineTop < 0) {
      scroller.scrollTop += lineTop;
    } else if (lineBottom > scroller.clientHeight) {
      scroller.scrollTop += Math.min(lineTop, lineBottom - scroller.clientHeight);
    }
  }

  theme.morph = morph;
  theme.morphNode = morphNode;
  theme.morphKeepValue = keepValue;
})();
